import { FormField } from '@r-and-a-shared-ui/common-forms-ui';
import { kontentAiDataMapping } from '@r-and-a-shared-ui/core-data-mapping';

import type {
  MEMBERSHIP_MODELS,
  PLAYER_PORTALS_MODELS,
  SSO_MODELS,
} from '@r-and-a-shared-ui/common-kontent-client';
export default {
  component: () => FormField,
  mapEntryToProps: (
    entry: SSO_MODELS.FormField &
      MEMBERSHIP_MODELS.FormField &
      PLAYER_PORTALS_MODELS.FormField,
  ) => kontentAiDataMapping.form_field(entry),
};
